// 工单相关配置

//工单类型
export const businessTypes = {
  FZTX: 33 //复诊提醒工单
}
// 含有子工单的工单类型,并且需要显示子工单弹窗
export const subOrderTypes = [businessTypes.FZTX]

// 配置工单二级tabs
export const infoDetails = {
  workOrderAntChat: {
    //详情展示的tabs
    supportTabs: ['workorderDetails', 'chat'],
    activeKey: 1 // tabs默认激活的key
  }
}

//子工单类型 还可以配置其他子工单类型
export const followBusinessTypes = {
  1: {
    title: '医生',
    //详情配置
    infoDetails: infoDetails.workOrderAntChat
  },
  2: {
    title: '患者'
  }
}
